import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl-next';
import { isGlobalExperienceWorkspaceForCloudId } from '../../../common/clients/atlas-rest-client';
import { useSearchConfigContext } from '../../../common/search-config-provider';
import { messages } from './messages';
import { SearchDialogProduct } from '../../product-router';
import { useGenericFilters, useSiteFilterDefinition } from '../../filters';
import { getSections } from './sections';
import { TOWNSQUARE_PRODUCT_ID, useTownsquareSuppliers } from './townsquare-item-suppliers';
import { TownsquareScope } from './types';
const defaultPermissionsSupplier = () => {
  const response = Object.values(TownsquareScope);
  return Promise.resolve(response);
};
export const TownsquareTabWithIntl = ({
  intl,
  preQueryItemSupplier,
  postQueryItemSupplier,
  userTeamConfig,
  workspaces,
  atlasClientBaseUrlOverride,
  organizationId,
  ...rest
}) => {
  const [isGlobalExperienceWorkspace, setGlobalExperienceWorkspace] = useState();
  const {
    atlasWorkspaces
  } = useSearchConfigContext();
  if (!workspaces) {
    workspaces = atlasWorkspaces;
  }
  const siteFilterDefinition = useSiteFilterDefinition(workspaces, TOWNSQUARE_PRODUCT_ID);
  const {
    preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
    postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
    preQuerySectionTitleGenerator
  } = useTownsquareSuppliers({
    userTeamConfig,
    preQueryItemSupplier,
    postQueryItemSupplier,
    workspaces,
    isGlobalExperienceWorkspace
  });
  const {
    defineFilters
  } = useGenericFilters();
  defineFilters(TOWNSQUARE_PRODUCT_ID, siteFilterDefinition);
  useEffect(() => {
    isGlobalExperienceWorkspaceForCloudId(userTeamConfig === null || userTeamConfig === void 0 ? void 0 : userTeamConfig.context.siteId, atlasClientBaseUrlOverride).then(result => {
      setGlobalExperienceWorkspace(result);
    }).catch(() => {
      setGlobalExperienceWorkspace(false);
    });
  }, [atlasClientBaseUrlOverride, userTeamConfig === null || userTeamConfig === void 0 ? void 0 : userTeamConfig.context.siteId]);
  let permissionSupplier = workspaces && workspaces.length > 0 || isGlobalExperienceWorkspace ? defaultPermissionsSupplier : rest.permissionSupplier;
  if (isGlobalExperienceWorkspace === undefined) {
    return null;
  }
  return /*#__PURE__*/React.createElement(SearchDialogProduct, _extends({}, rest, {
    id: TOWNSQUARE_PRODUCT_ID,
    expandedStateInputPlaceholder: intl.formatMessage(isGlobalExperienceWorkspace ? messages.townsquare_search_input_expanded_placeholder : messages.atlas_search_input_expanded_placeholder),
    sections: getSections(intl, workspaces, isGlobalExperienceWorkspace, userTeamConfig === null || userTeamConfig === void 0 ? void 0 : userTeamConfig.context.organizationId),
    title: intl.formatMessage(isGlobalExperienceWorkspace ? messages.townsquare_globex_tab_label : messages.townsquare_tab_label),
    preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
    preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
    postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
    workspaces: workspaces,
    permissionSupplier: permissionSupplier
  }), () => {
    return {
      // Atlas (Townsquare) doesn't have an advanced search url so rendering no Footer
      Footer: () => /*#__PURE__*/React.createElement(React.Fragment, null)
    };
  });
};
export const TownsquareTab = injectIntl(TownsquareTabWithIntl);